var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPlus = function SvgPlus(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "currentColor",
    style: {
      color: "#3b7cc9"
    }
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M4.229 7.333a.667.667 0 0 0 0 1.334h3.105v3.104a.667.667 0 1 0 1.333 0V8.667h3.104a.667.667 0 1 0 0-1.334H8.667V4.23a.667.667 0 0 0-1.333 0v3.104H4.229Z",
    clipRule: "evenodd"
  })));
};
export default SvgPlus;